<template>
  <div>
    <div
      class="d-flex justify-content-start align-items-center pointer"
      @click="visible = !visible"
    >
      <slot name="title"></slot>
      <i
        class="fal fa-chevron-down rotate ml-3 pt-1"
        :class="{ down: visible }"
      ></i>
    </div>

    <b-collapse role="tabpanel" v-model="visible">
      <slot name="content"></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'HMCollapse',
  props: {
    openVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: this.openVisible,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.pointer {
  cursor: pointer;
}

.rotate {
  transition: all 0.2s ease-in-out;
  &.down {
    transform: rotate(180deg);
  }
}
</style>
